import React, { memo } from 'react';
import { createPortal } from 'react-dom';

import BackdropHandler from '@/components/atomic/atoms/utils/portals/backdrop';
import DropdownHandler from '@/components/atomic/molecules/utils/portals/dropdown';
import withExposer from '@/hocs/with-exposer';
import usePortals from '@/hooks/use-portals';
import AuthoringHelper from '@/utils/authoring';

const PortalsComponent: React.FC = () => {
	const { portalEntryPoint } = usePortals();

	if (!portalEntryPoint || AuthoringHelper.isInEditor) return null;

	return createPortal(
		<>
			<BackdropHandler />
			<DropdownHandler />
		</>,
		portalEntryPoint,
	);
};

const Portals = memo(withExposer(PortalsComponent, 'portals'));

export default Portals;
